import { render, staticRenderFns } from "./AgriiProtector.vue?vue&type=template&id=73a8fd53"
import script from "./AgriiProtector.vue?vue&type=script&lang=js"
export * from "./AgriiProtector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports